import React from 'react';
const Footer = () => {
  return <div className='h-10'></div>;
};
export default Footer;
